export const FafKey = {
  PRODUCT_ID: 'productId',
  FUEL_SOLD: 'fuelSold'
};
export const FafLabel = {
  PRODUCT_ID: 'Product / Service Name',
  FUEL_SOLD: 'Fuel Sold'
};
